<template>
  <div
    class="members"
    :class="{'search-open': searchWindowOpen, 'search-closed': !searchWindowOpen, 'visitors': activeTab !== 1}"
  >
    <hr id="hr-search">
    <p class="members__search-label">{{ trans.get('pages:members.filters_panel.mobile_header') }}</p>
    <div v-if="show" class="members__mobile-input">
      <div class="mobile-input__nick">
        <div class="form-group">
          <input
            id="nickname"
            class="input--primary custom-outline"
            :placeholder="trans.get('pages:members.filters_panel.find_by_nick')"
            type="text"
            v-model="form.nickname"
          >
        </div>
      </div>
      <button
        type="button" class="button button__icon mobile-button__filters"
        @click="searchWindowOpen=!searchWindowOpen"
      >
        <i class="demo-icon icon-down"></i>
      </button>
    </div>
    <transition name="fade" appear>
      <SearchForm v-show="searchWindowOpen" v-model="form" :enable-nickname="!show" :active-tab="activeTab">
      </SearchForm>
    </transition>

    <div class="radio-switch__wrapper">
      <div class="radio-switch">
        <input
          class="radio-switch__input radio-switch__input--neighbours"
          type="radio"
          name="neighbours-visitors"
          id="neighbours"
          v-model="activeTab"
          :value="1"
        >
        <label
          class="radio-switch__label radio-switch__label--neighbours"
          for="neighbours"
        >
          {{ trans.get('pages:members.tabs.neighbours') }}
        </label>

        <input
          class="radio-switch__input radio-switch__input--visitors"
          type="radio"
          name="neighbours-visitors"
          id="visitors"
          v-model="activeTab"
          :value="2"
        >
        <label
          class="radio-switch__label radio-switch__label--visitors"
          for="visitors"
        >
          {{ trans.get('pages:members.tabs.visitors') }}
          <UnseenVisitorCountComponent></UnseenVisitorCountComponent>
        </label>

        <span class="radio-switch__slider"></span>
      </div>
    </div>
    <div v-if="loadingPhotos" class="members__grid">
      <div v-for="index in 10" :key="index" class="members__profile">
        <div class="profile-card profile-card__image" style="background-color: #f5f5f5; width: 100%">
          <div style="background-color: #ccc"></div>
        </div>
      </div>
    </div>

    <div
      v-show="!loadingPhotos && searchResults.length !== 0"
      id="members-cards"
      class="members__grid"
      v-infinite-scroll="loadMore"
      infinite-scroll-immediate-check="false"
      infinite-scroll-disabled="busy"
      infinite-scroll-distance="300"
    >
      <div class="members__profile" v-for="(profile,k) in searchResults" :key="k">
        <div class="profile-card">
          <profile-card
            :profile="profile"
            :isVisitor="activeTab === 2"
            :isTopChoice="activeTab === 3"
            :isOther="false"
            @buy="openBuyModal"
          >

          </profile-card>
        </div>
      </div>
    </div>

    <div v-show="activeTab === 2 && !loadingPhotos && visitorsPage.length === 0" class="members__empty">
      <div class="empty__icon">
        <img src="../../../images/background/no-visitors.png" alt="No visitors image" />
      </div>
      <h2 class="empty__title title">
        {{ trans.get('pages:visitors.empty.title') }}<span>.</span>
      </h2>
      <p class="empty__desc desc">
        {{ trans.get('pages:visitors.empty.slogan') }}.
      </p>
      <router-link :to="{name: 'match_game'}" class="empty__button button button--primary">
        {{ trans.get('pages:visitors.empty.button') }}
      </router-link>
    </div>

    <div v-if="showMoreResults" id="more-results" class="row justify-content-center align-items-center my-3">
      <div class="col">
        <hr>
      </div>
      <div class="col-auto desc desc--lightgrey">
        {{ trans.get('pages:members.filters_panel.other_profiles_label') }}
      </div>
      <div class="col">
        <hr>
      </div>
    </div>

    <div v-if="showMoreResults" class="members__grid">
      <div class="members__profile" v-for="profile in otherProfilesResults">
        <div class="profile-card">
          <profile-card :profile="profile" :isTopChoice="activeTab === 3" :isOther="true" @buy="openBuyModal">
          </profile-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import SearchMixin from '../../../../js/front/components/Members/SearchMixin';
import ProfileCard from './ProfileCard';
import 'vue-slider-component/theme/default.css';
import UnseenVisitorCountComponent from './UnseenVisitorCountComponent';
import SearchForm from './SearchForm';

var infiniteScroll = require('vue-infinite-scroll');

export default {
  name: 'SearchCard',
  components: { SearchForm, UnseenVisitorCountComponent, ProfileCard },
  directives: { infiniteScroll },
  mixins: [SearchMixin],
  data() {
    return {
      show: false,
      screenWidth: 0
    };
  },
  computed: {},
  watch: {
    activeTab: function (newValue, oldVale) {
      window.location.hash = this.tabHash[newValue];
    },
    screenWidth: function () {
      this.toggleSearch();
    }
  },
  methods: {
    toggleSearch() {
      if (this.screenWidth < 1200) {
        this.show = true;
        this.searchWindowOpen = false;
      } else {
        this.show = false;
        this.searchWindowOpen = true;
      }
    }
  },
  created() {
    window.addEventListener('resize', () => {
      this.screenWidth = window.innerWidth;
    });
    this.screenWidth = window.innerWidth;
    this.toggleSearch();
  }
};
</script>


<style scoped>

</style>
